import { createContext, useContext } from 'react';


const FigurePanelIdContext = createContext();//"fp0");

export function useFigurePanelId(){
  return useContext(FigurePanelIdContext);
}

export default function FigurePanelIdProvider({children,figurePanelId}){

  return (
    <FigurePanelIdContext.Provider value={figurePanelId}>
      {children}
    </FigurePanelIdContext.Provider>
  )


}
